import { PrescribedItem } from '../../../../types'

export const isQuantityMissing = (item: PrescribedItem) =>
  !Number.isFinite(Number(item.quantity)) || Number(item.quantity) <= 0
